import { render, staticRenderFns } from "./CancleBooking.vue?vue&type=template&id=120fe732&scoped=true"
import script from "./CancleBooking.vue?vue&type=script&lang=js"
export * from "./CancleBooking.vue?vue&type=script&lang=js"
import style0 from "./CancleBooking.vue?vue&type=style&index=0&id=120fe732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120fe732",
  null
  
)

export default component.exports